let Vue

function extend (Vue) {
	Vue.directive('img-detect', (el) => {
		let img = el
		if (img.src !== '') {
			let tmp = new Image()
			tmp.addEventListener('load', () => {
				el.classList.add((tmp.width > tmp.height) ? 'landscape' : 'portrait')
				el.classList.remove((tmp.width > tmp.height) ? 'portrait' : 'landscape')
			})
			tmp.src = img.src
		}
	})
}

function _install (_Vue) {
	Vue = _Vue
	extend(Vue)
}

let ImageDetect = class ImageDetect {}

ImageDetect.install = _install
ImageDetect.version = '0.0.1'

export default ImageDetect



// WEBPACK FOOTER //
// ./src/common/directives/ImageDetect.js